var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseVeeForm',{attrs:{"action":_vm.submit},scopedSlots:_vm._u([{key:"default",fn:function(formProps){return [_c('BaseCard',{staticClass:"max-w-lg w-full mx-auto"},[_c('BaseCardHeader',[_c('h3',{staticClass:"text-base font-medium"},[_vm._v("Edit Sms message")])]),_c('BaseCardBody',[_c('BaseFormTextareaFieldWithValidator',{staticClass:"max-w-lg",attrs:{"validator":{
            name: 'content',
            vid: 'content',
            rules: {
              required: true,
            },
          },"field":{
            label: 'Message content',
            id: 'content',
          },"disabled":formProps.isPending},model:{value:(_vm.data.content),callback:function ($$v) {_vm.$set(_vm.data, "content", $$v)},expression:"data.content"}}),_c('BaseFormInlineMessage',{attrs:{"info":""}},[_vm._v(" Message Length: "+_vm._s(_vm.totalChars)+", Total messages: "+_vm._s(_vm.totalMessages)+" ")])],1),_c('BaseCardFooter',{attrs:{"gray":""}},[_c('BaseButton',{attrs:{"primary":"","disable":formProps.isPending}},[_vm._v(" Update ")])],1)],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }